import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, Component, useRef } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
} from "reactstrap"

import TableComponent from './Components/TableComponent'
import { Link } from 'react-router-dom'

const IndexView = (props) => {
    const activeRef = useRef();
    const inactiveRef = useRef();

    const peg_uuid = JSON.parse(localStorage.getItem('userdata'))

    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()

    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <div className="float-end">
                        {
                            (accessRole('create')) ?
                                <Link to="?create">
                                    <Button color="primary">Tambah Data Mutasi</Button>
                                </Link>
                            : null
                        }
                        </div>
                        <CardTitle>Daftar Mutasi PPI/PPPI</CardTitle>
                        <CardSubtitle className="mb-3">
                        </CardSubtitle>
                        <hr/>
                        <TableComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} uuid={peg_uuid?.employee_uuid} />
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )
}

export default IndexView